import React, { useEffect, useRef } from 'react';

const PropagationBanner = ({ message, onDismiss }) => {
  const onDismissRef = useRef(onDismiss);
  onDismissRef.current = onDismiss;

  useEffect(() => {
    if (!message) {
      return undefined;
    }
    const timer = setTimeout(() => {
      onDismissRef.current();
    }, 8000);
    return () => clearTimeout(timer);
  }, [message]);

  if (!message) {
    return null;
  }

  return (
    <div className="runtime-config-banner runtime-config-banner-success" role="status" data-testid="propagation-banner">
      {message}
    </div>
  );
};

export default PropagationBanner;
